function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { spacing4, spacing8, spacing16, spacing24, spacing32, spacing48, spacing64, spacing128 } from "@churchofjesuschrist/eden-style-constants";
const gaps = {
  0: "0",
  4: spacing4,
  8: spacing8,
  16: spacing16,
  24: spacing24,
  32: spacing32,
  48: spacing48,
  64: spacing64,
  128: spacing128
};
const Container = styled.div.withConfig({
  componentId: "sc-xsbnfo-0"
})(["display:grid;grid-auto-columns:100%;", ";"], _ref => {
  let {
    columnGapSize,
    rowGapSize,
    gapSize,
    min
  } = _ref;
  return `
    @media (min-width: ${min}) {
      grid-template-columns: repeat( auto-fit, minmax(${min}, 1fr) );
    }
    grid-column-gap: ${gaps[columnGapSize] || gaps[gapSize]};
    grid-row-gap: ${gaps[rowGapSize] || gaps[gapSize]};
  `;
});

const Grid = _ref2 => {
  let {
    gapSize = "16",
    columnGapSize,
    rowGapSize,
    min = "9.375rem",
    children,
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(Container, _extends({
    gapSize,
    columnGapSize,
    rowGapSize,
    min
  }, props), children);
};

const gapsKeys = Object.keys(gaps);
Grid.propTypes = {
  /** Grid items */
  children: PropTypes.node.isRequired,

  /** A valid px, rem, or em unit that defines the minimum size of each grid item before wrapping */
  min: PropTypes.string,

  /** Gutter space between columns and rows */
  gapSize: PropTypes.oneOf(gapsKeys),

  /** Overrides gapSize for column gutter space only */
  columnGapSize: PropTypes.oneOf(gapsKeys),

  /** Overrides gapSize for row gutter space only */
  rowGapSize: PropTypes.oneOf(gapsKeys)
};
export default Grid;